export const EVENT_ICON_CLICK = "click";
export const EVENT_ICON_KEYDOWN = "keydown";
